module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.inline) ? _c('label', {
    staticClass: "checkbox-inline",
    staticStyle: {
      "padding-right": "20px"
    }
  }, [_c('input', {
    ref: "checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.optionValue,
      "checked": _vm.isChecked
    },
    on: {
      "change": _vm.updateModel
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.optionText)
    }
  })]) : _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    ref: "checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.optionValue,
      "checked": _vm.isChecked
    },
    on: {
      "change": _vm.updateModel
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.optionText)
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-211b883a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-211b883a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./application/components/form/checkbox.vue
// module id = 395
// module chunks = 1